export default "__VITE_ASSET__D_NZ0kcF__"